import { useState, useEffect } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { supabase } from '@/lib/supabase'

export function useConnectionVersion() {
  const { user } = useAuth()
  const [version, setVersion] = useState<number>(2)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user?.account_id || !supabase) {
      setVersion(2)
      setLoading(false)
      return
    }

    const sb = supabase
    const fetch = async () => {
      try {
        const { data } = await sb
          .from('account_instances')
          .select('connection_version')
          .eq('account_id', user.account_id)
          .maybeSingle()
        setVersion(data?.connection_version ?? 2)
      } catch {
        setVersion(2)
      } finally {
        setLoading(false)
      }
    }
    fetch()
  }, [user?.account_id])

  const getUrl = (baseName: string) => {
    const suffix = version === 3 ? '-v3' : version === 2 ? '-v2' : ''
    return `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/${baseName}${suffix}`
  }

  return { version, loading, getUrl, setVersion }
}
